/**
 * Content insertion utilities
 * 
 * This module provides utilities for:
 * - Inserting nodes with automatic spacing
 */

import {getTextBeforeRange, endsWithWhitespace} from './textHelpers';
import {applyRangeToSelection} from './rangeHelpers';

export function insertWithSpacing(
    element: HTMLElement,
    range: Range,
    node: Node,
    selection: Selection
): void {
    if(!element || !range || !node || !selection) return;
    
    const textBefore = getTextBeforeRange(element, range);
    const needsSpaceBefore = textBefore.length > 0 && !endsWithWhitespace(textBefore);

    if(needsSpaceBefore) {
        range.insertNode(document.createTextNode(' '));
        range.setStartAfter(range.startContainer);
    }

    range.insertNode(node);
    range.setStartAfter(node);
    range.insertNode(document.createTextNode(' '));
    range.setStartAfter(range.startContainer);
    range.collapse(true);

    applyRangeToSelection(range);
}
